import { render, staticRenderFns } from "./InstantPaymentHandler.vue?vue&type=template&id=df598b46&scoped=true"
import script from "./InstantPaymentHandler.vue?vue&type=script&lang=js"
export * from "./InstantPaymentHandler.vue?vue&type=script&lang=js"
import style0 from "./InstantPaymentHandler.vue?vue&type=style&index=0&id=df598b46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df598b46",
  null
  
)

export default component.exports